module.exports = __webpack_public_path__ + "static/media/CS3 — 8.667a79db.PNG";